import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/media/GYM9.jpg'
import _imports_1 from '../assets/media/GYM1.jpg'
import _imports_2 from '../assets/media/GYM15.jpg'
import _imports_3 from '../assets/media/GYM16.jpg'
import _imports_4 from '../assets/media/GYM5.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "embed-video-title home-16" }, "Discover The Best", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("iframe", {
  class: "embed-video",
  src: "https://www.youtube.com/embed/cg3mqfUZLZM",
  frameborder: "0",
  allowfullscreen: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "embed-video-title home-17" }, "Relaxation That Your Body Needs", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("iframe", {
  class: "embed-video",
  src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FDilaFormulaze%2Fvideos%2F235966662805348%2F",
  frameborder: "0",
  allowfullscreen: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "embed-video-title home-18" }, "Our Grand Opening", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("iframe", {
  class: "embed-video",
  src: "https://drive.google.com/file/d/1mzcD19B0eY5AMZS5suk-uVeVkBp8F4eK/preview",
  allow: "autoplay",
  frameborder: "0",
  allowfullscreen: ""
}, null, -1)
const _hoisted_7 = { class: "page-paragraph-container" }
const _hoisted_8 = { class: "home-page-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "p-header home-1" }, "Introduction", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "p-container home-2" }, " Welcome to the future of fitness at Gold's Gym Tbilisi, our brand-new gym in the heart of Tbilisi, Georgia! We're excited to offer you an exclusive opportunity to join Gold's Gym Tbilisi's vibrant community and embark on a journey to a healthier and fitter lifestyle. Our state-of-the-art facility is equipped with the latest fitness equipment, experienced trainers, and a range of classes to cater to your fitness needs. Whether you're a seasoned fitness enthusiast or just starting your fitness journey, Gold's Gym Tbilisi has something for everyone. Join us and become a part of Gold's Gym Tbilisi's supportive community dedicated to achieving fitness goals and embracing a positive lifestyle. ", -1)
const _hoisted_11 = { class: "p-button" }
const _hoisted_12 = { class: "open-container-button" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-img",
  src: _imports_0,
  alt: "gym-equipment"
}, null, -1)
const _hoisted_14 = { class: "page-paragraph-container right" }
const _hoisted_15 = { class: "home-page-container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "p-header home-4" }, "About Us", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "p-container home-5" }, " At Gold's Gym, our story is one of passion, empowerment, and transformation. Founded in 1965 by Joe Gold in Venice Beach, California, Gold's Gym has evolved from a local gym to an iconic global fitness brand. Our heritage in bodybuilding and strength training laid the foundation for a community that values hard work and dedication. With a legacy spanning decades, Gold's Gym has become synonymous with fitness excellence. We are not just a gym; we are a community united by a shared commitment to health and wellness. Our experienced trainers, cutting-edge equipment, and diverse range of classes are all tailored to help you achieve your goals. Join us and be part of a legacy that continues to inspire countless individuals to embrace a healthier, stronger, and more vibrant lifestyle. ", -1)
const _hoisted_18 = { class: "p-button right-button" }
const _hoisted_19 = { class: "open-container-button" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-img",
  src: _imports_1,
  alt: "gym-equipment"
}, null, -1)
const _hoisted_21 = { class: "page-paragraph-container" }
const _hoisted_22 = { class: "home-page-container" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "p-header home-7" }, "Check Out Our Place", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "p-container home-8" }, " Welcome to the Gold's Gym Experience! Explore our Gallery to catch a glimpse of the energy and dedication that flows through our gym. Our state-of-the-art facilities are designed to inspire and motivate, providing the perfect environment for you to challenge yourself and reach your fitness goals. From high-tech cardio machines to cutting-edge weightlifting equipment, our gallery showcases the diverse range of fitness options available to our members. Scroll through images of our group fitness classes, personal training sessions, and the vibrant community that makes Gold's Gym more than just a gym - it's a lifestyle. Get ready to embark on a visual journey that captures the essence of Gold's Gym. ", -1)
const _hoisted_25 = { class: "p-button" }
const _hoisted_26 = { class: "open-container-button" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-img",
  src: _imports_2,
  alt: "gym-equipment"
}, null, -1)
const _hoisted_28 = { class: "page-paragraph-container right" }
const _hoisted_29 = { class: "home-page-container" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "p-header home-10" }, "Our Products", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "p-container home-11" }, " Discover Gold's Gym's premium fitness products that complement your workout journey. We are committed to equipping you with top-notch gear designed to enhance your fitness experience. Our product range includes everything from performance activewear that moves with you to accessories that elevate your training sessions. Whether you're hitting the weights, mastering yoga poses, or pushing your limits on the track, our products are designed to support your goals. At Gold's Gym, we believe that your fitness journey deserves the best, and our product offerings reflect that commitment. Browse through our carefully curated selection and gear up with the tools you need to excel in your workouts. ", -1)
const _hoisted_32 = { class: "p-button right-button" }
const _hoisted_33 = { class: "open-container-button" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-img",
  src: _imports_3,
  alt: "gym-equipment"
}, null, -1)
const _hoisted_35 = { class: "page-paragraph-container" }
const _hoisted_36 = { class: "home-page-container" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", { class: "p-header home-13" }, "Top Staff", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "p-container home-14" }, " Connecting with our dedicated team of fitness professionals is just a click away. Gold's Gym takes pride in curating a team of the best trainers and personnel, each bringing a wealth of expertise and passion to guide you on your fitness journey. Our trainers are more than instructors - they're motivators, educators, and partners in your pursuit of wellness. With a diverse range of specialties, from strength training and cardiovascular conditioning to yoga and functional fitness, our trainers are equipped to cater to your unique needs. Whether you're a seasoned athlete or just starting out, our team is committed to helping you reach your goals safely and effectively. Contact us today to discover how Gold's Gym's exceptional trainers and personnel can empower you to unlock your full fitness potential. ", -1)
const _hoisted_39 = { class: "p-button" }
const _hoisted_40 = { class: "open-container-button" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-img",
  src: _imports_4,
  alt: "gym-equipment"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "default-button-container home-3",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Find Out About Us")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, {
              class: "default-button-container home-6",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Learn More")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_20
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_router_link, {
              class: "default-button-container home-9",
              to: "/gallery"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Look Into Gallery")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_27
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_router_link, {
              class: "default-button-container home-12",
              to: "/product"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Product Page")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_34
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_router_link, {
              class: "default-button-container home-15",
              to: "/contacts"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Our Contacts")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_41
    ])
  ], 64))
}